import styled from "styled-components";

export const LabelTitle = styled.label`
  color: ${({ theme }) => theme.default_text_color};
  font-weight: ${props => (props.weight ? props.weight : "500")};
  font-size: ${({ theme }) => theme.textXXs};
`;
